export default __webpack_public_path__ + "static/hummingbird-pattern-b9755a96f80ae40f649ca1b7bd1cc22c.png";